export enum LoadingStage {
  NOT_STARTED = 'NOT_STARTED',
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR'
}

export enum EmptyStage {
  EMPTY = 'EMPTY'
}

export type ResponseStage = LoadingStage | EmptyStage;
